<div class="box is-fullwidth" style="height: fit-content; max-width: 500px">
  <p class="is-size-4">Offers: Pending Approval ({pendingApprovalCount})</p>
  <table class="table is-fullwidth">
    <thead>
      <tr>
        <th />
      </tr>
    </thead>
    <tbody>
      {#each showAll ? nameLinkMap : nameLinkMap.slice(0, 10) as tableRow, index}
        <tr>
          <td style="display: flex; justify-content: space-between">
            <a href={tableRow.headingLink}>{tableRow.heading}</a>
            {#if pendingApprovalCount > 10 && index === 9 && !showAll}
              <button
                class="tag is-light"
                style="cursor: pointer"
                on:click={handleShowAll}>Show all</button
              >
            {:else if showAll && index === pendingApprovalCount - 1}
              <button
                class="tag is-light"
                style="cursor: pointer"
                on:click={handleShowAll}>Show less</button
              >
            {/if}
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
</div>

<script lang="ts">
  let showAll = false;
  let pendingApprovals: Offer_v2_Doc[] = [];

  $: pendingApprovalCount = pendingApprovals.length;
  $: nameLinkMap = pendingApprovals.map((offer) => ({
    heading: offer.data.name,
    headingLink: `/admin/offer/${offer.id}`,
  }));

  let firebase = window.firebase;

  firebase
    .firestore()
    .collection('offers_v2')
    .onSnapshot((snap) => {
      pendingApprovals = snap.docs
        .map((doc) => ({ id: doc.id, data: doc.data() } as Offer_v2_Doc))
        .filter((offer) => offer.data.status === 'pending-approval');
    });

  function handleShowAll() {
    showAll = !showAll;
  }
</script>
